module.exports = "/_next/static/images/2a153176e50f58df7511d2cdc633308b-digital-account-phone-main-screen@xs-2x.png.webp";